module.exports = __webpack_public_path__ + "static/media/white-freehand-line-measure-icon.5a6cc819.svg";